const equals = { label: 'Igual', value: 'equals' };
const contains = { label: 'Contém', value: 'contains' };
const endsWith = { label: 'Termina com', value: 'endsWith' };
const startsWith = { label: 'Começa com', value: 'startsWith' };
const gt = { label: 'Maior que', value: 'gt' };
const gte = { label: 'Maior ou igual a', value: 'gte' };
const lt = { label: 'Menor que', value: 'lt' };
const lte = { label: 'Menor ou igual a', value: 'lte' };


export const availableOperations = {
  text: [equals, contains, endsWith, startsWith],
  number: [equals, gt, gte, lt, lte],
  date: [gt, gte, lt, lte]
};